export default __webpack_public_path__ + "static/geos-chem720-164fca2a12cf58206972a6a73bc7d599.mp4";